export const siteMetadata = {
  title: 'Marvel & Snap',
  description: '',
  author: 'Marvel & Snap',
  siteUrl: 'https://www.marvelandsnap.com',
};
